<template>
  <div>
    <v-select
      v-model="answer"
      :items="getOptionsSelect(question.options)"
      label="Seleccione"
      @change="$emit('get_answer', { option: answer, question: question})"
    ></v-select>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  data(){
    return {
      answer: ""
    }
  },
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  methods: {
    getOptionsSelect(options) {
      let filtered = [];
      options.forEach(function(element) {
        filtered.push(element.title);
      });
      return filtered;
    }
  }
};
</script>

<style>
</style>